var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.topic)?_c('div',[(_vm.topic.get('kind') == 1)?_c('post-topic',{attrs:{"topic":_vm.topic}}):_vm._e(),_vm._v(" "),(_vm.topic.get('kind') == 2)?_c('jielong-topic',{attrs:{"topic":_vm.topic}}):_vm._e(),_vm._v(" "),(_vm.topic.get('kind') == 3)?_c('feihua-topic',{attrs:{"topic":_vm.topic}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c51dc9ec","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Topic.vue
// module id = 1630
// module chunks = 0